// DevPatch.ts
//
// Development-only substitute for the bundled AV runtime boundary.
// ScorecardBuilder depends only on this object when visual AV is active;
// all transport details remain contained here.
export class DevPatch {
    constructor(baseUrl = "http://127.0.0.1:5174") {
        this.baseUrl = baseUrl.replace(/\/$/, "");
    }
    static async tryConnect(baseUrl = "http://127.0.0.1:5174", timeoutMs = 200) {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), timeoutMs);
        try {
            const response = await fetch(`${baseUrl}/av/health`, {
                method: "GET",
                signal: controller.signal,
            });
            if (!response.ok) {
                return undefined;
            }
            return new DevPatch(baseUrl);
        }
        catch {
            return undefined;
        }
        finally {
            window.clearTimeout(timeout);
        }
    }
    async sendSelectedGames(selectedGames) {
        const response = await fetch(`${this.baseUrl}/av/selected-games`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                selectedGames,
            }),
        });
        if (!response.ok) {
            throw new Error(`Visual AV rejected SelectedGames: ${response.status} ${response.statusText}`);
        }
    }
    async processRawGameSummaries(rawGameSummaries) {
        const response = await fetch(`${this.baseUrl}/av/raw-game-summaries`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(rawGameSummaries),
        });
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Visual AV failed: ${response.status} ${errorText}`);
        }
        return await response.text();
    }
}
//# sourceMappingURL=DevPatch.js.map